'use client';

import { useEffect } from 'react';
import { noop } from 'utils/noop';
import { portalRootIdentifer } from '../Portal/Portal';

/**
 * Set aria-hidden={true} on all non overlayed elements for
 * accessibility. This is used when a Dialog is open.
 */
export function useHideBody(rootRef: any, enabled = true) {
  useEffect(() => {
    const originalValues: any[] = [];
    const rootNodes: HTMLElement[] = [];

    if (enabled) {
      Array.prototype.forEach.call(
        document.querySelectorAll(
          `body > *:not([data-${portalRootIdentifer}])`
        ),
        (node: HTMLElement) => {
          if (node === rootRef.current || node.contains(rootRef.current)) {
            return;
          }

          const attr = node.getAttribute('aria-hidden');
          const alreadyHidden = attr !== null;
          if (alreadyHidden) {
            return;
          }
          originalValues.push(attr);
          rootNodes.push(node);
          node.setAttribute('aria-hidden', 'true');
        }
      );

      return () => {
        rootNodes.forEach((node, index) => {
          const originalValue = originalValues[index];
          if (originalValue === null) {
            node.removeAttribute('aria-hidden');
          } else {
            node.setAttribute('aria-hidden', originalValue);
          }
        });
      };
    }

    return noop;
  }, [rootRef, enabled]);
}
